import * as React from 'react';
import { Paper, makeStyles } from '@material-ui/core';
import { styles } from 'components/Table/Table.styles';
import TableToolbar from 'components/TableToolbar';
import Table from 'components/Table/Table';
import { TableConfigEntry } from 'utils/tableConfig';
import ConnectedTableFilters from 'components/Table/ConnectedTableFilters';
import ConnectedButton from 'components/Button/ConnectedButton';
import InternalLink from 'components/Link/InternalLink';
import { useSongThemes } from 'novaApi/hooks/song_theme';

const useStyles = makeStyles(styles);

const tableConfig: TableConfigEntry<Nl.Api.SongTheme> = {
  columnData: [
    { id: 'name', label: 'Name', isSortable: true },
    {
      id: 'parent',
      label: 'Parent Theme',
      render: ({ parent }) => parent?.name || '-',
    },
    {
      id: 'songs',
      label: 'Songs',
      render: ({ song_count, uuid }) =>
        song_count < 1 ? (
          song_count
        ) : (
          <InternalLink
            color='inherit'
            to={{
              type: 'route/SONGS',
              payload: { query: { theme_uuid: uuid } },
            }}
          >
            {song_count}
          </InternalLink>
        ),
    },
  ],
};

export default function SongThemePage() {
  const data = useSongThemes();
  const classes = useStyles({});

  return (
    <Paper elevation={1} className={classes.root}>
      <TableToolbar
        title='Song Theme'
        search={
          <ConnectedTableFilters
            filters={[
              {
                type: 'search',
                size: 6,
                label: 'Search by name',
                queryFilterKey: 'name',
                e2e: 'name',
              },
            ]}
          />
        }
        actions={
          <ConnectedButton
            icon='add'
            fab
            route='route/SONG_THEME_CREATE'
            label='Create song theme'
            permission='CAN_CREATE_SONG_THEMES'
          />
        }
      />
      <Table
        config={tableConfig}
        data={data?.song_themes ?? []}
        isLoaded={!!data}
        paginationData={data}
      />
    </Paper>
  );
}
